// extracted by mini-css-extract-plugin
export default {"wrapper":"lang_wrapper__oZffM","current":"lang_current__OuAm4"};